import React from 'react';

import ContentfulImage from '../ContentfulImage';
import RichTextConverter from '../RichText/RichTextConverter';
import * as styles from './SideScroll.module.scss';

export default function Bleed({ content, contentRef }) {
  return (
    <div className={styles.bleed} ref={contentRef}>
      {content.map((card, i) => (
        <div
          key={i}
          className={styles.content}
          data-analytics-component={'bleeding-card'}
          data-analytics-id={card.title}
        >
          <ContentfulImage lazy={true} className={styles.backgroundImage} imageFragment={card.image} />
          <div className={styles.copy}>
            <h3 className={styles.title}>{card.title}</h3>
            <RichTextConverter copy={card.body} />
          </div>
        </div>
      ))}
    </div>
  );
}
